import React from 'react';

const Image = ({ data, ...rest }) => <img src={data.url} alt={data.alt} {...rest} />;

export default Image;
